export interface GetMarketKeyParams {
  storeId: string;
  marketId: string | number;
}

export const getMarketKey = (market: GetMarketKeyParams): string => {
  // API 연동 마켓은 기존대로
  return `${market.storeId}_${market.marketId}`;
};
